import api from './axios';
import { authHeader } from '../helpers';
import { authService } from './authentication.service';

export const surveillanceService = {
    getAll,
    getById,
    getAllByUtam,
    getArborescence,
    getArborescenceActive,
    getPointsToposByRdN,
    getPointsToposByView,
    getDataPointsTopos,
    getAllDataPointsTopos,
    getDataPointsToposBrute,
    getReseauNivellementBySurv,
    getReseauNivellementByUtam,
    getVariableFromArbo,
    getResponsables,
    getVariableData,
    getVariablesData,
    getVariablesGrapheur,
    getDpsmVariableData,
    getListeUnites,
    getUnitesBySerieType,
    getAllViews,
    getViewsBySurv,
    getView,
    saveView,
    updateView,
    deleteView,
    createVariableCalculee,
    updateVariableCalculee,
    deleteVariableCalculee,
    getTypeCalculVariableCalculee,
    getVariableCalculeeById,
    getFrequenceVariableCalculee
}

async function getAll() {
    return api.get('/Surveillance', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getById(survId) {
    return api.get(`/Surveillance/${survId}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getAllByUtam(utam) {
    return api.get(`/Surveillance/utam/${utam}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getReseauNivellementBySurv(survId) {
    return api.get(`/Surveillance/surv/${survId}/reseau_nivellement`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getReseauNivellementByUtam(utam) {
    return api.get(`/Surveillance/utam/${utam}/reseau_nivellement`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getPointsToposByRdN(rdnIdElement) {
    return api.get(`/Surveillance/element/${rdnIdElement}/points_topos`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getPointsToposByView(idView, pointsTopos, timeRange) {
    const start = (timeRange?.start) ? new Date(timeRange.start) : new Date(new Date(Date.now()).getFullYear() - 1, 0, 1);
    const end = (timeRange?.end) ? new Date(timeRange.end) : new Date(Date.now());

    return api.post(`/Variables/pointsTopos/vue/${idView}`, { pointsTopos, start, end }, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getDataPointsTopos(guids, dateDebut, dateFin, maxMeasureCount, isLambert = true) {
    const params = new URLSearchParams({
        variableGuids: guids,
        dateDebut,
        dateFin,
        maxResultCount: maxMeasureCount,
        isLambert: isLambert
    });

    return api.get(`/Variables/pointsTopos?${params.toString()}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getAllDataPointsTopos(guids, maxMeasureCount) {
    const params = new URLSearchParams({
        variableGuids: guids,
        maxResultCount: maxMeasureCount
    });

    return api.get(`/Variables/pointsTopos/all?${params.toString()}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getDataPointsToposBrute(guids, dateDebut, dateFin, maxMeasureCount) {
    const params = new URLSearchParams({
        variableGuids: guids,
        dateDebut,
        dateFin,
        maxResultCount: maxMeasureCount
    });

    return api.get(`/Variables/pointsTopos/brute?${params.toString()}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getArborescence(survId) {
    return api.get(`/Surveillance/${survId}/arborescence_direct`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getArborescenceActive(survId) {
    return api.get(`/Surveillance/${survId}/arborescence_active`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getVariableFromArbo(guidVariable) {
    return api.get(`/Surveillance/getVariableFromAllArbo/${guidVariable}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getResponsables(survId) {
    return api.get(`/Surveillance/${survId}/responsables`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getVariableData(guid) {
    return api.get(`/Variables/${guid}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getVariablesData(guids) {
    const params = new URLSearchParams();
    guids.forEach(guid => params.append('variableGuids', guid));

    return api.get(`/Variables/multiple?${params.toString()}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getVariablesGrapheur(guids, dateDebut, dateFin, maxMeasureCount) {
    const params = new URLSearchParams({
        variableGuids: guids,
        dateDebut,
        dateFin,
        maxResultCount: maxMeasureCount
    });

    return api.get(`/Variables/grapheur?${params.toString()}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
        .catch(error => {
            throw error;
        });
}

async function getAllViews() {
    return api.get('/Grapheur', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getViewsBySurv(survId) {
    const params = new URLSearchParams({ survId });

    return api.get(`/Grapheur/utam?${params.toString()}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getView(viewId) {
    return api.get(`/Grapheur/${viewId}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function saveView(saveView) {
    return api.post('/Grapheur/writeGrapheurVue', saveView, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function updateView(saveView) {
    return api.patch('/Grapheur/writeGrapheurVue', saveView, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function deleteView(idView) {
    return api.delete(`/Grapheur/deleteGrapheurVue/${idView}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getDpsmVariableData(variableGuid) {
    return api.get(`/Variables/Dpsm/${variableGuid}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getListeUnites() {
    return api.get('/Variables/unite/List', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getUnitesBySerieType(serieTypeId) {
    return api.get(`/Variables/unite/ListByType/${serieTypeId}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function createVariableCalculee(vm) {
    return api.post('/Variables/variablesCalculees', vm, {
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        }
    })
        .then(authService.handleResponse)
        .then(data => data);
}

async function updateVariableCalculee(id, vm) {
    return api.put(`/Variables/variablesCalculees/${id}`, vm, {
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        }
    })
        .then(authService.handleResponse)
        .then(() => true);
}

async function deleteVariableCalculee(id) {
    return api.delete(`/Variables/variablesCalculees/${id}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
        .then(() => true);
}

async function getTypeCalculVariableCalculee() {
    return api.get('/Variables/variablesCalculees/typecalcul', {
        headers: authHeader()
    })
        .then(authService.handleResponse)
        .then(data => data);
}

async function getFrequenceVariableCalculee() {
    return api.get('/Variables/variablesCalculees/frequence', {
        headers: authHeader()
    })
        .then(authService.handleResponse)
        .then(data => data);
}

async function getVariableCalculeeById(id) {
    return api.get(`/Variables/variablesCalculees/${id}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
        .then(data => data);
}

